import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  IconButton,
  Button,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

export type CorporateIndividual = {
  name: string;
  percentage: string;
};

type CorporateIndividualsTableProps = {
  values: CorporateIndividual[];
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
};

const CorporateIndividualsTable = ({
  values,
  setFieldValue,
}: CorporateIndividualsTableProps) => {
  const handleAddRow = () => {
    const newRows = [...values, { name: "", percentage: "" }];
    setFieldValue("corporateIndividuals", newRows);
  };

  const handleChangeRow = (
    index: number,
    field: keyof CorporateIndividual,
    value: string
  ) => {
    const newRows = values.map((row, idx) =>
      idx === index ? { ...row, [field]: value } : row
    );
    setFieldValue("corporateIndividuals", newRows);
  };

  const handleRemoveRow = (index: number) => {
    const newRows = values.filter((_, idx) => idx !== index);
    setFieldValue("corporateIndividuals", newRows);
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead
            sx={{
              backgroundColor: "lightcoral",
              "& .MuiTableCell-root": {
                fontWeight: "bold",
                color: "text.primary",
              },
            }}
          >
            <TableRow>
              <TableCell>Industry</TableCell>
              <TableCell align="right">%</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {values.map((row, index) => (
              <TableRow key={index}>
                <TableCell>
                  <TextField
                    fullWidth
                    placeholder="Industry"
                    value={row.name}
                    onChange={(e) =>
                      handleChangeRow(index, "name", e.target.value)
                    }
                  />
                </TableCell>
                <TableCell align="right">
                  <TextField
                    fullWidth
                    placeholder="%"
                    value={row.percentage}
                    onChange={(e) =>
                      handleChangeRow(index, "percentage", e.target.value)
                    }
                  />
                </TableCell>
                <TableCell align="center">
                  <IconButton onClick={() => handleRemoveRow(index)}>
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Button variant="outlined" onClick={handleAddRow} sx={{ mt: 2 }}>
        Add Row
      </Button>
    </>
  );
};

export default CorporateIndividualsTable;
